import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, inject } from '@angular/core';
import { IUser } from 'src/app/shared/models';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { FundraiserSliderImgModule } from '../fundraiser-slider-img/fundraiser-slider-img.module';
import { MatIconModule } from '@angular/material/icon';
import { NgxGlideModule } from 'ngx-glide';
import { FundraiserCardComponent } from 'src/app/core/fundraiser-card/fundraiser-card.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { WidgetModule } from '../widget/widget.module';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-ended-fundraiser-v2',
  templateUrl: './ended-fundraiser-v2.component.html',
  styleUrls: ['./ended-fundraiser-v2.component.scss'],
  imports: [CommonModule, FundraiserSliderImgModule, MatIconModule, NgxGlideModule, FundraiserCardComponent, SharedModule, WidgetModule],
})
export class EndedFundraiserV2Component implements OnInit, OnDestroy {

  public utils: UtilService = inject(UtilService);
  public vars: VariablesService = inject(VariablesService);
  private events: EventsService = inject(EventsService);
  private router:Router = inject(Router);

  @Input() fundraiser;
  @Input() endedCampaignPageData;
  @Input() endedCampaignPageDataType;
  @Input() currency;
  @Input() pageType;
  @Input() title: string;
  @Input() subtitle: string | null;
  @Input() utmSource: string | null;
  @Output() goToFundraiserEvent = new EventEmitter<void>();
  @Output() goToFundraiserUpdatesEvent = new EventEmitter<void>();
  
  supporterImages: string[];

  beneficiaryName="";

  isMobile = this.utils.isMobile();

  breakpoints = {
    600: {
      perView: 1.6,
    }
  };
  isReloaded:boolean =false;

  utmObj;

  constructor() {}

  ngOnInit(): void {
    this.setSupporterImages();

    this.utmObj = {
      utm_source: this.utmSource ? this.utmSource : 'organic',
      utm_medium: 'EndedCampaignPage',
      utm_campaign: this.fundraiser.id
    }
    this.getBeneficiaryName();

    this.events.sendSystemEvent({
      eventName: 'landed_on_ended_campaign',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
      page_name: 'EndedCampaignPage',
      ...this.utmObj
    }).subscribe(_ => _);

    // this.vars.userData.subscribe(res => {
    //   console.log(res)
    //   if(res !== null){
    //     // window.location.reload();
    //   }
    // });
    this.vars.afterLoginRedirectsHit.subscribe(res => {
      console.log(res)
      if (res) {
         window.location.reload();
      }
    })
  }

  setSupporterImages = () => {
    this.supporterImages = Array.from({ length: 3 }, () => {
      const randomNum = Math.floor(Math.random() * 34) + 1; // Random number between 1 and 34
      return `/assets/images/supporters/supporter-${randomNum}.png`;
    });
  }

  getBeneficiaryName() {
    if (this.fundraiser && this.fundraiser.beneficiary) {
      this.beneficiaryName = this.fundraiser?.beneficiary?.full_name || this.vars?.basicInfo?.beneficiary_name;
    } else if (this.fundraiser?.beneficiaryname) {
      this.beneficiaryName = this.fundraiser?.beneficiaryname?.info_1;
    } else {
      this.beneficiaryName = this.vars?.basicInfo?.beneficiary_name;
    }
  }

  goToFundraiser() {
    this.goToFundraiserEvent.emit();
    this.events.sendSystemEvent({
      eventName: 'user_exited_without_action',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
      page_name: 'EndedCampaignPage',
      ...this.utmObj
    }).subscribe(_ => _);
  }

  goToFundraiserUpdates() {
    this.goToFundraiserUpdatesEvent.emit();
    this.events.sendSystemEvent({
      eventName: 'view_updates_clicked',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
      page_name: 'EndedCampaignPage',
      ...this.utmObj
    }).subscribe(_ => _);
  }

  goToBrowseFundraiser() {
    this.utils.router.navigate(['/crowdfunding/fundraisers'])
    this.events.sendSystemEvent({
      eventName: 'redirect_to_similar_campaign',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
      page_name: 'EndedCampaignPage',
      ...this.utmObj
    }).subscribe(_ => _);
  }

  onDownloadKettoApp() {
    const redLink = this.utils.isIOSDevice() || this.utils.isAppleDevice() ? this.vars.appLink.iOS : this.vars.appLink.android;
    this.utils.nativeNavigation(redLink, true)
    this.events.sendSystemEvent({
      eventName: 'ketto_download_app_clicked',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
      page_name: 'EndedCampaignPage',
      ...this.utmObj
    }).subscribe(_ => _);
  }

  ngOnDestroy(): void {
    // Cleanup logic here
  }
} 